<template>
  <div class="text-justify" :style="{ 'background-color': bgcolor }">
    {{ sentence }}
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    sentence: String,
    highlight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bgcolor() {
      return this.highlight ? "rgba(252, 245, 38, 0.3)" : "#FFF";
    },
  },
};
</script>

<style>
</style>